import React from 'react';
import { BoardTermsList } from '../components/board/BoardTermsList';

export default function BoardTermsPage() {
    return <BoardTermsList />;
}
